import { Injectable } from "@angular/core";
import { AllocationBulkingService, CubiqWorker } from "shared/cubiq-services";
import { OEAdapterForwardService } from "./adapter/oe-adapter-forward.service";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { OENOperationMode } from "../data/enums/oe-operation-mode.enum";
import { OENPanel } from "../data/enums/oe-panel.enum";
import { OENInputControl } from "../data/enums/oe-input-control.enum";
import { OEInputModel } from "app/order-entry/data/models/oe-input.model";

@Injectable()
export class OEAllocationBulkService {
  constructor(
    private worker: CubiqWorker,
    private forwardAdapter: OEAdapterForwardService,
    private bulkingService: AllocationBulkingService,
  ) {}

  public getBulkReport(
    rootRefId: string,
    allocations: Partial<CubiqTS.AllocationRequestData>[],
    operationMode: OENOperationMode,
  ): Promise<CubiqTS.StandardReport> {
    let errors: Array<OEInputModel> = [];
    let requestOrder = new CubiqTS.FixingOrderRequestImpl();
    let requestOrderData = new CubiqTS.FixingOrderRequestDataImpl();
    let isValid = this.forwardAdapter.prepareBmarkOrderRequestData(
      rootRefId,
      errors,
      operationMode,
      requestOrderData,
      new Set([
        `${OENPanel.PANEL_FINANCIALS}_${OENInputControl.ORDER_AMOUNT}`,
        `${OENPanel.PANEL_FINANCIALS}_${OENInputControl.FIXING_DATE}`,
        `${OENPanel.PANEL_FINANCIALS}_${OENInputControl.ALLOCATIONS}`,
      ]),
      true,
    );
    requestOrder.fixingOrderData = requestOrderData;
    if (!isValid) {
      return Promise.reject(errors);
    }

    requestOrderData.allocations = allocations.map((a) =>
      Object.assign(new CubiqTS.AllocationRequestDataImpl(), a, {
        settleDate: this.getSettleDate(a),
      }),
    );

    return this.bulkingService.sendBMBulkingRequests([requestOrder]);
  }

  public getSettleDate(a: Partial<CubiqTS.AllocationRequestData>): CubiqTS.StandardDateImpl {
    let settleDate: Date = (a as unknown as any).settleDate;
    if (settleDate != null && settleDate instanceof Date) {
      let date = new CubiqTS.StandardDateImpl();
      date.year = settleDate.getFullYear();
      date.month = settleDate.getMonth() + 1;
      date.day = settleDate.getDate();
      return date;
    } else if (settleDate != null && settleDate instanceof CubiqTS.StandardDateImpl) {
      return settleDate;
    }
    return null;
  }
}
